// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — item.classic.js, новая — item.cp.js
import { isCp } from 'libs/design';
import * as classic from './item.classic';
import * as cp from './item.cp';

export const Item = isCp ? cp.Item : classic.Item;
